import React from "react";
import PageSeo from "components/Seo/PageSeo";
import { SITE_DESCRIPTION, DEFAULT_PAGE_TITLE } from "helpers/seo/siteConfig";
import { localBusinessSchema, webSiteSchema } from "helpers/seo/schema";
import Hero from "components/Home/Hero/Hero";
import TrustBar from "components/Home/TrustBar/TrustBar";
import KidsJoyStrip from "components/Home/KidsJoyStrip/KidsJoyStrip";
import ProgramGrid from "components/Home/ProgramGrid/ProgramGrid";
import HomeClassFinder from "components/Home/HomeClassFinder/HomeClassFinder";
import WhyAce from "components/Home/WhyAce/WhyAce";
import StaffTeaser from "components/Home/StaffTeaser/StaffTeaser";
import VisitUs from "components/Home/VisitUs/VisitUs";
import ScrollReveal from "components/Home/ScrollReveal/ScrollReveal";
import "components/Home/homeShared.css";
import "./Home.css";

const Home = () => (
  <main className="home-page">
    <PageSeo
      title={DEFAULT_PAGE_TITLE}
      description={SITE_DESCRIPTION}
      path="/"
      jsonLd={[localBusinessSchema(), webSiteSchema()]}
    />
    <Hero />
    <ScrollReveal>
      <TrustBar />
    </ScrollReveal>
    <ScrollReveal>
      <KidsJoyStrip />
    </ScrollReveal>
    <HomeClassFinder />
    <ScrollReveal>
      <ProgramGrid />
    </ScrollReveal>
    <ScrollReveal>
      <WhyAce />
    </ScrollReveal>
    <ScrollReveal>
      <StaffTeaser />
    </ScrollReveal>
    <ScrollReveal>
      <VisitUs />
    </ScrollReveal>
  </main>
);

export default Home;
